import {Icon, Question, Settings} from "../Shared/Model/GameData";
import {Quiz} from "../Shared/Model/QuizData";
import {ScoreDataPoints} from "../Shared/Components/Score";

export interface QuizPlayState {
    currentIndex: number
    currentScore: number
    icons : Icon[]
    selectedAnswerIndex?: number,
    isAnswerCorrect?: boolean,
}

export default class QuizManager {
    private quiz: Quiz
    private settings: Settings

    private currentIndex: number = 0
    private currentScore: number = 0
    private selectedAnswerIndex: number | undefined = undefined
    private icons : Icon[] = []

    constructor(quiz: Quiz, settings: Settings) {
        this.quiz = quiz
        this.settings = settings
    }

    answer(index: number) {
        const question = this.currentQuestion()
        const answer = question.answers[index]
        this.currentScore += answer.points
        this.selectedAnswerIndex = index
        if(question.icon) {
            this.icons.push(question.icon)
        }
    }

    next(): boolean {
        if (this.currentIndex >= this.quiz.questions.length - 1) {
            return false
        }
        this.currentIndex++
        this.selectedAnswerIndex = undefined
        return true
    }

    state(): QuizPlayState {
        return {
            currentIndex: this.currentIndex,
            currentScore: this.currentScore,
            selectedAnswerIndex: this.selectedAnswerIndex,
            icons : this.icons,
            isAnswerCorrect: this.selectedAnswerIndex === undefined ? undefined
                : this.currentQuestion().answers[this.selectedAnswerIndex].correct
        }
    }

    currentQuestion(): Question {
        return this.quiz.questions[this.currentIndex]
    }

    hint() : string|undefined {
        if (this.selectedAnswerIndex !== undefined) {
            return this.currentQuestion().explanation
        } else if(this.currentIndex === 0) {
            return this.settings.explanation
        }
        return undefined
    }

    score() : ScoreDataPoints {
        return {
            type : "points",
            questionNumber : this.currentIndex+1,
            questionCount : this.quiz.questions.length,
            score : this.currentScore,
            scoreMax : this.scoreMax(),
        }
    }

    private scoreMax(): number {
        return this.quiz.questions
            .flatMap(q => q.answers)
            .reduce((points, a) => points + a.points, 0)
    }
}